<template>
  <div
    class="min-h-screen bg-gray-900 flex flex-col md:justify-center overflow-y-auto md:overflow-hidden"
  >
    <div
      class="w-full min-h-full md:min-h-0 flex items-center justify-center p-4"
    >
      <div
        class="w-full max-w-md bg-gray-800 p-6 md:p-8 rounded-xl shadow-lg my-4"
      >
        <!-- Content will go here -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyView',
};
</script>
